/* eslint-disable */
/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config file > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/



import {QSpinnerFacebook,Notify,LoadingBar,Dialog} from 'quasar'



const userOptions = { config: {"loading":{"spinner":"QSpinnerFacebook"}},components: {QSpinnerFacebook},plugins: {Notify,LoadingBar,Dialog} }
  
userOptions.config.loading.spinner = QSpinnerFacebook
  
  
export default userOptions

